import Box from '@mui/material/Box';
import { msgTypes } from 'constants/msgTypes';
import { BlogModel } from 'model/screensModels/BlogModel';
import { PaginatorModel } from 'model/utilModels/PaginatorModel';
import * as React from 'react';
import { useState } from 'react';
import { DataNotFound } from 'screens/sharedScreens/dataNotFound/DataNotFound';
import { BlogService } from 'services/menu/blogService/BlogService';
import ApiUrl from 'services/shared/ApiUrl';
import BlogList from './BlogList';
import CreateBlog from './CreateBlog';
import DOMPurify from 'dompurify';

export default function Blog() {
  const [updateValue, setUpdateValue] = React.useState(new BlogModel());
  const [flag, setFlag] = useState(false)
  const [recentBlog, setRecentBlog] = useState(new BlogModel());
  const [isEditMode, setIsEditMode] = useState(false);

  React.useEffect(()=>{
    loadRecentBlog();
  },[])

  //Prepare request body to get blog list
  const prepareRequest = () => {
    const requestBody = new PaginatorModel();
    requestBody.pageNumber = 0;
    requestBody.pageSize = 1;
    return requestBody;
  }

  //Get Blog list
  const loadRecentBlog = async () => {
    const requestBody = prepareRequest();
    const res = await BlogService.getBlogList(requestBody);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      if(res?.data!==''){
         setRecentBlog(res?.data?.tbody[0]);
      }else{
        setRecentBlog(new BlogModel());
      }
    }
  }

  //to get update record value
  const getUpdateRecordValue = (blogModel: BlogModel) => {
    setIsEditMode(true);
    setUpdateValue(blogModel);
  }

  const addBlog = () => {
    setUpdateValue(new BlogModel())
    setIsEditMode(false); // Reset edit mode
    setFlag(true);
  }

  const RecentBlogs = () => {
    return (
      <>
        <h5 className='pb-3 recent-heading'>Recently added Blog </h5>
        {recentBlog.blogId!=='' ? (
        <div>
          <div className='row recent-row'>
            <div className='col-lg-4 '>
              <h5>Title : </h5>
            </div>
            <div className='col-lg-8'>
              {recentBlog.title}
            </div>
          </div>

          <div className='row recent-row'>
            <div className='col-lg-4 '>
              <h5>Description : </h5>
            </div>
            <div className='col-lg-8'
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(recentBlog.description || "") }}

>
            </div>

          </div>

          <div className='row recent-row'>
            <div className='col-lg-4 '>
              <h5>Blog Image : </h5>
            </div>
            <div className='col-lg-8'>
              <img src={ApiUrl.fileBaseUrl + recentBlog.image} className="recentdded-section"></img>
            </div>
          </div>
        </div>
        ) :(
          <>
          <DataNotFound message="There is no Blog"/>
          </>
         )}
      </>
    )
  }

  return (
    <>
      <Box sx={{ width: '100%' }} className="container container-h-full">
        <Box>
        <div className="content-subheader">
            {!flag ? (
              <h2 className="mr-3 font-weight-bolder">Blog List</h2>
            ) : (
              <h2 className="mr-3">{isEditMode ? 'Edit Blog' : 'Add Blog'}</h2>
            )}
            {!flag && <button className="btn primary" onClick={addBlog}>Add Blog</button>}
          </div>
        </Box>
        
          {!flag ?
            (<div className='sub-content-sec recently-blog'>
              <BlogList setFlag={setFlag} updateRecord={getUpdateRecordValue} loadRecentBlog={loadRecentBlog} ></BlogList>
            </div>)
            :
            <>
              <div>
                <div className='row'>
                  <div className='col-lg-5 work'>
                    <div className='sub-content-sec recently-blog'>
                      <RecentBlogs />
                    </div>
                  </div>
                  <div className='col-lg-7'>
                    <div className='sub-content-sec recently-blog'>
                      <CreateBlog setFlag={setFlag} updateRecord={updateValue} loadRecentBlog={loadRecentBlog}></CreateBlog>
                    </div>
                  </div>
                </div>
              </div>
            </>
          }
      </Box>
    </>
  );
}